import { env } from '@/app/config/env';

const apiUrl = env.API_URL.replace(/\/$/, '');

export function resolveAmenityImageUrl(
  url?: string | null,
): string | undefined {
  if (!url) {
    return undefined;
  }

  if (
    url.startsWith('http://') ||
    url.startsWith('https://') ||
    url.startsWith('blob:') ||
    url.startsWith('data:')
  ) {
    return url;
  }

  const normalizedPath = url.startsWith('/') ? url : `/${url}`;
  return apiUrl ? `${apiUrl}${normalizedPath}` : normalizedPath;
}

/** Strip API base prefix before sending photoUrl back to the backend. */
export function toRelativeAmenityImageUrl(
  url?: string | null,
): string | null {
  if (!url || url.startsWith('blob:')) {
    return null;
  }

  if (apiUrl && url.startsWith(apiUrl)) {
    const rest = url.slice(apiUrl.length);
    return rest.startsWith('/') ? rest : `/${rest}`;
  }

  return url;
}
